<template>
  <div class="menuBuilder">
    <div class="listWrapper">
      <div class="menuListTitle">可选择菜单</div>
      <ul class="menusList" id="preSelectList">
        <li class="menusListItem disabled">
          <div class="header">
            <CIcon class="menuIcon" icon="caidan-shouye" size="19"></CIcon>
            <div class="title">首页</div>
          </div>
        </li>
        <li
          v-for="(menu, index) in alternativeMenus"
          class="menusListItem"
          :class="{ disabled: menu._disabled }"
          :key="menu.id"
          :data-id="menu.id"
        >
          <div class="header">
            <CIcon class="menuIcon" :icon="menu.icon"></CIcon>
            <div class="title">
              <div class="cmsc-ellipsis">{{ menu.title }}</div>
            </div>
            <CIcon
              v-if="menu.children && menu.children.length > 0"
              class="menuIcon foldBtn"
              :class="{ actived: menu._actived }"
              icon="tongyong-zhankailiebiao1"
              @click="toggleFold('alternative', menu)"
            ></CIcon>
            <div v-if="menu.type === 'custom'" class="handles">
              <CIcon
                v-show="!menu._disabled"
                class="menuIcon"
                icon="tongyong-bianji"
                @click="openMenuInfoEditor(menu)"
              ></CIcon>
              <Poptip
                word-wrap
                width="244"
                v-if="menu._disabled"
                transfer
                confirm
                title="删除该菜单后，已被放置到右侧“自定义菜单”中的“自定义菜单1”也将被删除，你确定删除该菜单吗？"
                @on-ok="deleteCustomMenu(menu.id, index)"
              >
                <CIcon class="menuIcon" icon="tongyong-shanchu"></CIcon>
              </Poptip>
              <Poptip
                v-else
                transfer
                confirm
                width="244"
                title="你确定删除该菜单吗？"
                @on-ok="deleteCustomMenu(menu.id, index)"
              >
                <CIcon class="menuIcon" icon="tongyong-shanchu"></CIcon>
              </Poptip>
            </div>
          </div>

          <ul
            class="subMenusList"
            :data-id="menu.id"
            :class="{ opened: menu._actived }"
          >
            <li
              v-for="subMenu in menu.children"
              class="menusListItem"
              :class="{ disabled: subMenu._disabled }"
              :key="subMenu.id"
              :data-id="subMenu.id"
            >
              <div class="header">
                <div class="title">{{ subMenu.title }}</div>
              </div>
            </li>
          </ul>
        </li>
        <div
          class="addMenuBtn theme-font-primary-color cmsc-cursor-pointer"
          @click="openMenuInfoEditor()"
        >
          <CIcon icon="tongyong-xinjian"></CIcon>新建菜单
        </div>
      </ul>
    </div>

    <div class="listWrapper">
      <div class="menuListTitle">自定义菜单</div>
      <ul class="menusList" id="selectedList">
        <li class="menusListItem fixed" data-index="0">
          <div class="header">
            <Icon class="menuIcon handle" type></Icon>
            <CIcon class="menuIcon " icon="caidan-shouye" size="19"></CIcon>
            <div class="title">首页</div>
          </div>
        </li>
        <li
          v-for="menu in selectedMenus"
          class="menusListItem"
          :key="menu.id"
          :data-id="menu.id"
        >
          <div class="header">
            <CIcon
              class="menuIcon handle"
              icon="tongyong-paixu"
              size="15px"
            ></CIcon>
            <CIcon class="menuIcon" :icon="menu.icon"></CIcon>
            <div class="title">{{ menu.title }}</div>
            <CIcon
              v-if="menu.path !== '/settings'"
              class="menuIcon deleteBtn"
              icon="huihua-guanbihuihua1"
              @click="deleteMenu(menu.id)"
            ></CIcon>
            <CIcon
              class="menuIcon foldBtn"
              :class="{ actived: menu._actived }"
              :icon="
                menu.children && menu.children.length > 0
                  ? 'tongyong-zhankailiebiao1'
                  : ''
              "
              @click="toggleFold('selected', menu)"
            ></CIcon>
          </div>
          <ul
            class="subMenusList"
            :data-id="menu.id"
            :class="{ opened: menu._actived }"
          >
            <li
              v-for="subMenu in menu.children"
              :key="subMenu.id"
              :data-id="subMenu.id"
              class="menusListItem"
            >
              <div class="header">
                <Icon class="menuIcon handle" type="ios-menu"></Icon>
                <div class="title">{{ subMenu.title }}</div>
                <CIcon
                  v-if="menu.path !== '/settings'"
                  class="menuIcon deleteBtn"
                  icon="huihua-guanbihuihua1"
                  @click="deleteMenu(menu.id, subMenu.id)"
                ></CIcon>
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <Drawer
      :title="drawer.title"
      width="548"
      v-model="drawer.opened"
      @on-close="resetMenuEditor"
    >
      <MenuEditor
        ref="menuEditor"
        :data="drawer.data"
        @on-saved="menuEditorSaved"
        @on-cancel="resetMenuEditor"
      ></MenuEditor>
    </Drawer>
  </div>
</template>

<script>
import Sortable from 'sortablejs'
import MenuEditor from './MenuEditor'
export default {
  name: 'MenusBuilder',
  components: {
    MenuEditor
  },
  props: {
    alternativeMenus: {
      type: Array,
      default() {
        return []
      }
    },
    selectedMenus: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      sortInstances: {},
      mainSortInstances: [],
      subSortInstances: [],
      drawer: {
        opened: false,
        title: '新建菜单',
        data: null
      }
    }
  },
  computed: {
    customMenuCount() {
      let count = 0
      this.alternativeMenus.forEach(menu => {
        menu.type === 'custom' && count++
      })
      return count
    }
  },
  watch: {
    alternativeMenus(newValue, oldValue) {
      if (newValue !== oldValue) {
        console.log('alternativeMenus changed')
        this.destroySortInstances()
        this.$nextTick(() => {
          this.initSort()
          this.updateAlternativeMenusDisabledState()
        })
      }
    },
    selectedMenus(newValue, oldValue) {
      if (newValue !== oldValue) {
        console.log('selectedMenus changed')
        this.destroySortInstances()
        this.$nextTick(() => {
          this.initSort()
          this.updateAlternativeMenusDisabledState()
        })
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initSort()
      this.updateAlternativeMenusDisabledState()
    })
  },
  beforeDestroy() {
    this.destroySortInstances()
  },
  methods: {
    // 初始化预选菜单排序
    initSort() {
      this.sortInstances['preSelectList'] = new Sortable(
        document.querySelector('#preSelectList'),
        {
          group: {
            name: 'menusList',
            pull: 'clone',
            put: false
          },
          filter: '.disabled',
          sort: false,
          animation: 150,
          onMove: event => {
            const parentMenuId = event.dragged.dataset.id
            const parentMenuObj = this.selectedMenus.find(
              menu => menu.id === parentMenuId
            )
            if (parentMenuObj) return false // return false可以终止拖放操作
          }
        }
      )
      this.sortInstances['selectedList'] = new Sortable(
        document.querySelector('#selectedList'),
        {
          group: {
            name: 'menusList'
          },
          handle: '.handle',
          filter: '.fixed',
          swapThreshold: 0.5,
          invertSwap: true,
          animation: 150,
          onAdd: event => {},
          onMove: event => {
            // 排序为0的是首页，任何菜单不能在首页之上
            if (event.related.dataset.index === '0') return false
          },
          onSort: event => {
            // console.log(event)
            if (event.from !== document.querySelector('#preSelectList')) {
              const oldIndex = event.oldIndex - 1
              const newIndex = event.newIndex - 1
              this.selectedMenus.splice(
                newIndex,
                0,
                this.selectedMenus.splice(oldIndex, 1)[0]
              )
              this.selectedMenus[newIndex].index = newIndex
              if (oldIndex < newIndex) {
                for (let i = newIndex - 1; i >= oldIndex; i--) {
                  this.selectedMenus[i].index = i
                }
              } else {
                // oldIndex > newIndex
                for (let i = newIndex + 1; i <= oldIndex; i++) {
                  this.selectedMenus[i].index = i
                }
              }
              for (let i = 0; i < this.selectedMenus.length; i++) {
                this.selectedMenus[i].index = i;
              }
            } else {
              const parentMenuId = event.item.dataset.id
              const parentMenuObj = this.alternativeMenus.find(
                item => item.id === parentMenuId
              )
              // 目标树中删除排序工具拽过来的DOM，此DOM没有关联vm，无法做出响应，后面会通过数据的变更重新生成新的DOM
              event.target.removeChild(event.item)
              // 把来源树中克隆的DOM改为vm绑定的DOM
              event.from.insertBefore(event.item, event.clone)
              event.from.removeChild(event.clone)
              this.selectedMenus.splice(
                event.newIndex - 1,
                0,
                JSON.parse(JSON.stringify(parentMenuObj))
              )
              for (let i = event.newIndex - 1; i >= 0; i--) {
                this.selectedMenus[i].index = i
              }
              this.$set(parentMenuObj, '_disabled', true)
              for (let i = 0; i < this.selectedMenus.length; i++) {
                this.selectedMenus[i].index = i;
              }
              if (parentMenuObj.children && parentMenuObj.children.length > 0) {
                parentMenuObj.children.forEach(childMenu => {
                  this.$set(childMenu, '_disabled', true)
                })
              }
              this.$nextTick(() => {
                this.reFreashSort(
                  parentMenuId,
                  document.querySelector(
                    `#selectedList .subMenusList[data-id='${parentMenuId}']`
                  )
                )
              })
            }
          }
        }
      )
      document
        .querySelectorAll('#preSelectList .subMenusList')
        .forEach(node => {
          this.sortInstances[node.dataset.id] = this.createPreSelectChildSort(
            node.dataset.id,
            node
          )
        })
      document.querySelectorAll('#selectedList .subMenusList').forEach(node => {
        this.sortInstances[node.dataset.id] = this.createSelectedChildSort(
          node.dataset.id,
          node
        )
      })
    },
    createPreSelectChildSort(id, node) {
      return new Sortable(node, {
        group: {
          name: id,
          pull: 'clone',
          put: false
        },
        sort: false,
        filter: '.disabled',
        animation: 150,
        onStart: event => {
          const parentMenuId = event.to.dataset.id
          const parentMenuObj = this.selectedMenus.find(
            menu => menu.id === parentMenuId
          )
          if (parentMenuObj) this.$set(parentMenuObj, '_actived', true)
        },
        onMove: event => {
          const parentMenuId = event.to.dataset.id
          const parentMenuObj = this.selectedMenus.find(
            menu => menu.id === parentMenuId
          )
          const childMenuId = event.dragged.dataset.id
          const childMenuObj = parentMenuObj.children.find(
            item => item.id === childMenuId
          )
          if (childMenuObj) return false // return false可以终止拖放操作
        }
      })
    },
    createSelectedChildSort(id, node) {
      return new Sortable(node, {
        group: {
          name: id
        },
        handle: '.handle',
        animation: 150,
        swapThreshold: 0.5,
        invertSwap: true,
        onSort: event => {
          // console.log(event)
          const parentMenuId = event.from.dataset.id
          const fromNode = document.querySelector(
            `#preSelectList .subMenusList[data-id='${parentMenuId}']`
          )
          if (event.from !== fromNode) {
            const parentMenuObjOfSelected = this.selectedMenus.find(
              menu => menu.id === parentMenuId
            )
            const oldIndex = event.oldIndex
            const newIndex = event.newIndex
            parentMenuObjOfSelected.children.splice(
              newIndex,
              0,
              parentMenuObjOfSelected.children.splice(oldIndex, 1)[0]
            )
            parentMenuObjOfSelected.children[newIndex].index = newIndex
            if (oldIndex < newIndex) {
              for (let i = newIndex - 1; i >= oldIndex; i--) {
                parentMenuObjOfSelected.children[i].index = i
              }
            } else {
              // oldIndex > newIndex
              for (let i = newIndex + 1; i <= oldIndex; i++) {
                parentMenuObjOfSelected.children[i].index = i
              }
            }
          } else {
            const parentMenuId = event.from.dataset.id
            const parentMenuObjOfPreSelect = this.alternativeMenus.find(
              menu => menu.id === parentMenuId
            )
            const childMenuId = event.item.dataset.id
            const childMenuObj = parentMenuObjOfPreSelect.children.find(
              menu => menu.id === childMenuId
            )
            const parentMenuObjOfSelected = this.selectedMenus.find(
              menu => menu.id === parentMenuId
            )
            // 目标树中删除排序工具拽过来的DOM，此DOM没有关联vm，无法做出响应，后面会通过数据的变更重新生成新的DOM
            event.target.removeChild(event.item)
            // 把来源树中克隆的DOM改为vm绑定的DOM
            event.from.insertBefore(event.item, event.clone)
            event.from.removeChild(event.clone)
            parentMenuObjOfSelected.children.splice(
              event.newIndex - 1,
              0,
              JSON.parse(JSON.stringify(childMenuObj))
            )
            for (let i = event.newIndex; i >= 0; i--) {
              parentMenuObjOfSelected.children[i].index = i
            }
            this.$set(childMenuObj, '_disabled', true)
          }
        }
      })
    },
    // 刷新sort实例
    reFreashSort(SortId, node) {
      this.sortInstances[SortId] = this.createSelectedChildSort(SortId, node)
    },
    // 删除菜单项
    deleteMenu(parentMenuId, childMenuId) {
      const parentMenuIndex = this.selectedMenus.findIndex(
        menu => menu.id === parentMenuId
      )
      const parentMenuObjOfPreSelect = this.alternativeMenus.find(
        menu => menu.id === parentMenuId
      )

      if (childMenuId === undefined) {
        // 删除主菜单
        this.$delete(this.selectedMenus, parentMenuIndex)
        this.$set(parentMenuObjOfPreSelect, '_disabled', false)
        if (
          parentMenuObjOfPreSelect.children &&
          parentMenuObjOfPreSelect.children.length > 0
        )
          parentMenuObjOfPreSelect.children.forEach(menu => {
            this.$set(menu, '_disabled', false)
          })
      } else {
        // 删除字菜单
        const parentMenuObjOfSelected = this.selectedMenus[parentMenuIndex]
        const childMenuIndexOfSelected = parentMenuObjOfSelected.children.findIndex(
          menu => menu.id === childMenuId
        )
        this.$delete(parentMenuObjOfSelected.children, childMenuIndexOfSelected)
        const childMenuObjOfPreSelect = parentMenuObjOfPreSelect.children.find(
          menu => menu.id === childMenuId
        )
        this.$set(childMenuObjOfPreSelect, '_disabled', false)
        if (parentMenuObjOfSelected.children.length === 0)
          this.deleteMenu(parentMenuId)
        // this.$nextTick(() => {
        //   this.reFreashSort(
        //     parentMenuId,
        //     document.querySelector(
        //       `#selectedList .subMenusList[data-id='${parentMenuId}']`
        //     )
        //   )
        // })
      }
    },
    // 重置菜单选中状态
    resetPreMenusState(parentMenuId) {
      if (!parentMenuId) {
        // 不传parentMenuId认为是重置所有菜单
        this.alternativeMenus.forEach(menu => {
          this.$set(menu, '_disabled', false)
          if (menu.children && menu.children.length > 0) {
            menu.children.forEach(subMenu => {
              this.$set(subMenu, '_disabled', false)
            })
          }
        })
      } else {
        // 传parentMenuId时只充值此一级菜单下的二级菜单
        const firstLevelMenu = this.alternativeMenus.find(
          menu => menu.id === parentMenuId
        )
        firstLevelMenu.children.forEach(subMenu => {
          this.$set(subMenu, '_disabled', false)
        })
      }
    },
    // 切换菜单折叠状态
    toggleFold(source, menu) {
      // if(source === 'alternative') {
      this.$set(menu, '_actived', !menu._actived)
      // }
      // // console.log(e.path)
      // let menuItemNode = e.path[2]
      // menuItemNode.children[1].classList.toggle('opened')
    },
    // 打开菜单信息编辑器
    openMenuInfoEditor(menuData) {
      if (menuData) {
        this.$set(this.drawer, 'data', menuData)
        this.drawer.title = '修改菜单'
      } else {
        if (this.customMenuCount === 5)
          return this.$Message.warning('最多只能添加5个自定义菜单')
        this.drawer.data = null
        this.drawer.title = '新建菜单'
      }
      this.drawer.opened = true
    },
    resetMenuEditor() {
      this.drawer.opened = false
      this.drawer.data = null
      this.$refs.menuEditor.resetMenuEditor()
    },
    // 保存自定义菜单编辑
    menuEditorSaved(menu) {
      let hadMenuIndex = this.alternativeMenus.findIndex(
        _menu => _menu.id === menu.id
      )
      if (hadMenuIndex > -1) {
        this.$set(this.alternativeMenus, hadMenuIndex, menu)
      } else {
        this.alternativeMenus.push(menu)
      }
      this.$nextTick(() => {
        this.sortInstances[menu.id] = this.createPreSelectChildSort(
          menu.id,
          document.querySelector(
            `#preSelectList .subMenusList[data-id='${menu.id}']`
          )
        )
      })
      this.drawer.opened = false
    },
    // 删除自定义菜单
    deleteCustomMenu(id, index) {
      this.$http.delete('/sctm/menu/customMenu/' + id).then(() => {
        this.alternativeMenus.splice(index, 1)
        const selectedListIndex = this.selectedMenus.findIndex(
          menu => menu.id === id
        )
        if (selectedListIndex > -1)
          this.selectedMenus.splice(selectedListIndex, 1)
      })
    },
    // 卸载排序实例
    destroySortInstances() {
      for (let key in this.sortInstances) {
        this.sortInstances[key].destroy()
        delete this.sortInstances[key]
      }
    },
    // 更新预选区菜单禁用状态
    updateAlternativeMenusDisabledState() {
      for (let i = 0; i < this.selectedMenus.length; i++) {
        let selectedParentMenu = this.selectedMenus[i]
        let alternativeParentMenu = this.alternativeMenus.find(
          alternativeMenu => alternativeMenu.id === selectedParentMenu.id
        )
        if (!alternativeParentMenu) continue
        this.$set(alternativeParentMenu, '_disabled', true)
        if (
          selectedParentMenu.children &&
          selectedParentMenu.children.length > 0
        ) {
          selectedParentMenu.children.forEach(childMenu => {
            let childMenuObj = alternativeParentMenu.children.find(
              _alternativeMenu => _alternativeMenu.id === childMenu.id
            )
            this.$set(childMenuObj, '_disabled', true)
          })
        }
      }
    }
  }
}
</script>

<style lang="stylus">
.menuBuilder
  display flex
  height 100%

  .listWrapper
    display flex
    flex-flow column
    margin-right 24px

    .menuListTitle
      font-size 16px
      margin-bottom 15px

    #preSelectList
      width 284px

    #selectedList
      width 326px

  .addMenuBtn
    height 30px
    display flex
    justify-content center
    align-items center
    margin-top 16px
    font-size 14px

  .menusList
    flex auto
    height 0
    border 1px solid rgba(234, 240, 248, 1)
    border-radius 4px
    margin 0
    padding 0
    padding-bottom 50px
    overflow auto
    overflow-x hidden
    list-style none

    .menusListItem
      color #666778

      .header
        position relative
        display flex
        align-items center
        height 50px
        line-height 50px
        padding 0 16px
        border-bottom 1px solid #EAF0F8

        .menuIcon
          font-size 19px
          flex 0 0 25px
          transition transform 0.3s

          &.actived
            transform rotateZ(180deg)

        .handle
          margin-right 10px

        .title
          width 0
          font-size 14px
          flex auto
          padding-left 8px

        .handles
          position absolute
          right 50px
          background #fff
          display none

          .menuIcon
            margin-left 10px
            font-size 16px

        &:hover
          .handles
            display block

      &.disabled
        color #c3c3c3

        .handles
          color #666778

    .sortable-drag
      background rgba(255, 255, 255, 1)
      border 1px solid rgba(4, 203, 216, 1)
      box-shadow 0px 0px 16px 0px rgba(4, 203, 216, 0.4)

    .sortable-ghost
      background #E5FAFB

  .subMenusList
    @extend .menusList
    border none
    color #000
    height 0px
    padding 0

    &.opened
      height auto

    .menusListItem
      .header
        padding-left 40px
</style>
